module.exports = __webpack_public_path__ + "assets/img/news_32_logo2.c61d8d20.png";